import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import Link from '@nib-components/link';
import { copyFontSizeSmall } from '@nib-components/theme';
import { Inline, Container, breakpoint, mr } from '@nib/layout';
const RibbonWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: inherit;
`;
const RibbonLinks = styled.div`
  ${mr(5)};

  ${breakpoint('xl', 'xxl')`
    ${mr(3)};
  `}
`;
export const RibbonLink = styled(Link)`
  &&& {
    color: inherit;
    font-size: ${copyFontSizeSmall};
  }
`;
const Ribbon = _ref => {
  let {
    data,
    containerWidth,
    ...otherProps
  } = _ref;
  if (!data || data.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(RibbonWrapper, {
    ...otherProps,
    children: /*#__PURE__*/_jsx(Container, {
      width: containerWidth,
      children: /*#__PURE__*/_jsx(RibbonLinks, {
        children: /*#__PURE__*/_jsx(Inline, {
          space: 3,
          align: "right",
          children: data.map((link, i) => /*#__PURE__*/_jsx(RibbonLink, {
            id: `${link.id}-desktop`,
            href: link.url,
            title: link.title,
            children: link.title
          }, `item-${i}-${link.id}-desktop`))
        })
      })
    })
  });
};
export default Ribbon;